import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import { CheckoutWaiveDocument } from "src/app/models/enrollment-checkout";

@Component({
    selector: 'mwp-benefit-enrollment-checkout-waive-document',
    templateUrl: './waive-document.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CheckoutWaiveDocumentComponent implements OnInit {
    @Input() public checkoutWaiveDocument: CheckoutWaiveDocument;
    
    @Output() public emitComplete: EventEmitter<File[]> = new EventEmitter();

    public isValid: boolean;
    public files: File[];

    constructor(
    ) {
    }
    
    ngOnInit(): void{
    }

    public complete(): void {
        this.emitComplete.emit(this.files);
    }

    public updateFiles(event: File[]): void {
        this.files = event;
        this.isValid = this.files && this.files.length > 0;
    }
}